export const STUDENT_PAYMENTS_COPY = {
    default: {
        title: 'Payments & Discounts',
        loading: 'Loading payment details…',
        buttons: {
            close: 'Close',
        },
        summary: {
            outstanding: 'Outstanding Balance',
            approved: 'Approved Payments',
            referralEarnings: 'Referral Earnings',
            referralPending: 'Referral Pending',
        },
        referral: {
            heading: 'Referral Discounts',
            own: {
                heading: 'Your Referral Code',
                codeLabel: 'Code:',
                valueLabel: 'Value:',
                generatedLabel: 'Generated:',
                usedInfo: 'Used by {name} on {date}.',
                usedFallback: 'student ID {id}',
                generateNew: 'Generate New Referral Code',
                generate: 'Generate Referral Code',
                discountInfo: 'Students using your code receive {amount} off their tuition.',
                level2Info: 'You earn Referral #2 ({amount}) when a student applies your code.',
                level3Info: 'If that student shares a code and it is used, you earn Referral #3 ({amount}).',
            },
            apply: {
                heading: 'Apply a Referral Code',
                placeholder: 'REF-XXXX',
                providerInfo: 'Discount provided by {name}.',
                providerFallback: 'student ID {id}',
                submit: 'Apply Code',
                appliedLabel: 'Applied:',
            },
            messages: {
                generatedWithAmount: 'Referral code {code} generated! Share it with a new student so they can receive {amount} off their tuition.',
                generatedNoAmount: 'Referral code {code} generated! Share it with a new student.',
                applied: 'Referral code {code} applied successfully.',
            },
            errors: {
                enterCode: 'Enter a referral code to apply.',
                generateFailed: 'Failed to generate referral code.',
                applyFailed: 'Failed to apply referral code.',
            },
        },
        paymentForm: {
            heading: 'Submit Payment',
            amountLabel: 'Amount',
            methodLabel: 'Method',
            amountPlaceholder: 'Enter amount',
            submit: 'Submit for Approval',
            receiptLabel: 'Payment receipt (optional)',
            receiptDescription: 'Upload a receipt, invoice, or screenshot to speed up approval. PDF or image files up to 10 MB.',
            receiptSelected: 'Selected file:',
            removeReceipt: 'Remove file',
            methods: [
                { value: 'Online', label: 'Online' },
                { value: 'Cash', label: 'Cash' },
                { value: 'Check', label: 'Check' },
                { value: 'Other', label: 'Other' },
            ],
            errors: {
                amountInvalid: 'Enter a valid payment amount.',
                amountExceeds: 'Amount exceeds remaining balance.',
                submitFailed: 'Failed to submit payment.',
            },
        },
        history: {
            heading: 'Payment History',
            empty: 'No payments submitted yet.',
            columns: {
                date: 'Date',
                amount: 'Amount',
                method: 'Method',
                status: 'Status',
                notes: 'Notes',
                receipt: 'Receipt',
            },
            statusLabels: {
                APPROVED: 'Approved',
                PENDING: 'Pending',
                REJECTED: 'Rejected',
            },
            downloadReceipt: 'Download receipt',
            previewReceipt: 'Preview receipt',
        },
        preview: {
            title: 'Receipt Preview',
            close: 'Close Preview',
            unsupported: 'Preview unavailable. Download the file to view it.',
            loading: 'Loading receipt preview…',
            error: 'Failed to load receipt preview.',
        },
        messages: {
            paymentSubmitted: 'Payment submitted for approval.',
        },
        errors: {
            load: 'Failed to load payment details.',
        },
    },
    uk: {
        title: 'Платежі та знижки',
        loading: 'Завантаження платіжної інформації…',
        buttons: {
            close: 'Закрити',
        },
        summary: {
            outstanding: 'Залишок до сплати',
            approved: 'Підтверджені платежі',
            referralEarnings: 'Зароблено за рефералами',
            referralPending: 'Очікує за рефералами',
        },
        referral: {
            heading: 'Реферальні знижки',
            own: {
                heading: 'Ваш реферальний код',
                codeLabel: 'Код:',
                valueLabel: 'Сума:',
                generatedLabel: 'Згенеровано:',
                usedInfo: 'Використано {name} {date}.',
                usedFallback: 'студент ID {id}',
                generateNew: 'Згенерувати новий реферальний код',
                generate: 'Згенерувати реферальний код',
                discountInfo: 'Студенти, які використовують ваш код, отримують знижку {amount} на навчання.',
                level2Info: 'Ви отримуєте Реферал №2 ({amount}), коли студент застосовує ваш код.',
                level3Info: 'Якщо цей студент поділиться своїм кодом і його використають, ви отримуєте Реферал №3 ({amount}).',
            },
            apply: {
                heading: 'Застосувати реферальний код',
                placeholder: 'REF-XXXX',
                providerInfo: 'Знижку надав {name}.',
                providerFallback: 'студент ID {id}',
                submit: 'Застосувати код',
                appliedLabel: 'Застосовано:',
            },
            messages: {
                generatedWithAmount: 'Реферальний код {code} згенеровано! Поділіться ним із новим студентом, щоб він отримав знижку {amount} на навчання.',
                generatedNoAmount: 'Реферальний код {code} згенеровано! Поділіться ним із новим студентом.',
                applied: 'Реферальний код {code} успішно застосовано.',
            },
            errors: {
                enterCode: 'Введіть реферальний код для застосування.',
                generateFailed: 'Не вдалося згенерувати реферальний код.',
                applyFailed: 'Не вдалося застосувати реферальний код.',
            },
        },
        paymentForm: {
            heading: 'Надіслати платіж',
            amountLabel: 'Сума',
            methodLabel: 'Метод',
            amountPlaceholder: 'Введіть суму',
            submit: 'Надіслати на підтвердження',
            receiptLabel: 'Квитанція про оплату (необов’язково)',
            receiptDescription: 'Завантажте квитанцію, чек або скриншот, щоб пришвидшити підтвердження. До 10 МБ, PDF чи зображення.',
            receiptSelected: 'Вибраний файл:',
            removeReceipt: 'Видалити файл',
            methods: [
                { value: 'Online', label: 'Онлайн' },
                { value: 'Cash', label: 'Готівка' },
                { value: 'Check', label: 'Чек' },
                { value: 'Other', label: 'Інше' },
            ],
            errors: {
                amountInvalid: 'Введіть коректну суму платежу.',
                amountExceeds: 'Сума перевищує залишок до сплати.',
                submitFailed: 'Не вдалося надіслати платіж.',
            },
        },
        history: {
            heading: 'Історія платежів',
            empty: 'Платежів ще не надіслано.',
            columns: {
                date: 'Дата',
                amount: 'Сума',
                method: 'Метод',
                status: 'Статус',
                notes: 'Примітки',
                receipt: 'Квитанція',
            },
            statusLabels: {
                APPROVED: 'Підтверджено',
                PENDING: 'Очікує',
                REJECTED: 'Відхилено',
            },
            downloadReceipt: 'Завантажити квитанцію',
            previewReceipt: 'Переглянути квитанцію',
        },
        preview: {
            title: 'Перегляд квитанції',
            close: 'Закрити перегляд',
            unsupported: 'Перегляд недоступний. Завантажте файл, щоб переглянути його.',
            loading: 'Завантаження квитанції…',
            error: 'Не вдалося завантажити попередній перегляд квитанції.',
        },
        messages: {
            paymentSubmitted: 'Платіж надіслано на підтвердження.',
        },
        errors: {
            load: 'Не вдалося завантажити платіжні дані.',
        },
    },
    ru: {
        title: 'Платежи и скидки',
        loading: 'Загрузка платёжной информации…',
        buttons: {
            close: 'Закрыть',
        },
        summary: {
            outstanding: 'Остаток к оплате',
            approved: 'Одобренные платежи',
            referralEarnings: 'Реферальный доход',
            referralPending: 'Реферальные ожидания',
        },
        referral: {
            heading: 'Реферальные скидки',
            own: {
                heading: 'Ваш реферальный код',
                codeLabel: 'Код:',
                valueLabel: 'Сумма:',
                generatedLabel: 'Создано:',
                usedInfo: 'Использовано {name} {date}.',
                usedFallback: 'студент ID {id}',
                generateNew: 'Сгенерировать новый реферальный код',
                generate: 'Сгенерировать реферальный код',
                discountInfo: 'Студенты, использующие ваш код, получают скидку {amount} на обучение.',
                level2Info: 'Вы получаете Реферал №2 ({amount}), когда студент применяет ваш код.',
                level3Info: 'Если этот студент поделится кодом и его используют, вы получите Реферал №3 ({amount}).',
            },
            apply: {
                heading: 'Применить реферальный код',
                placeholder: 'REF-XXXX',
                providerInfo: 'Скидку предоставил {name}.',
                providerFallback: 'студент ID {id}',
                submit: 'Применить код',
                appliedLabel: 'Применено:',
            },
            messages: {
                generatedWithAmount: 'Реферальный код {code} создан! Поделитесь им с новым студентом, чтобы он получил скидку {amount} на обучение.',
                generatedNoAmount: 'Реферальный код {code} создан! Поделитесь им с новым студентом.',
                applied: 'Реферальный код {code} успешно применён.',
            },
            errors: {
                enterCode: 'Введите реферальный код.',
                generateFailed: 'Не удалось сгенерировать реферальный код.',
                applyFailed: 'Не удалось применить реферальный код.',
            },
        },
        paymentForm: {
            heading: 'Отправить платёж',
            amountLabel: 'Сумма',
            methodLabel: 'Способ',
            amountPlaceholder: 'Введите сумму',
            submit: 'Отправить на утверждение',
            receiptLabel: 'Квитанция об оплате (необязательно)',
            receiptDescription: 'Загрузите квитанцию, чек или скриншот, чтобы ускорить подтверждение. До 10 МБ, PDF или изображение.',
            receiptSelected: 'Выбранный файл:',
            removeReceipt: 'Удалить файл',
            methods: [
                { value: 'Online', label: 'Онлайн' },
                { value: 'Cash', label: 'Наличные' },
                { value: 'Check', label: 'Чек' },
                { value: 'Other', label: 'Другое' },
            ],
            errors: {
                amountInvalid: 'Введите корректную сумму платежа.',
                amountExceeds: 'Сумма превышает оставшийся баланс.',
                submitFailed: 'Не удалось отправить платёж.',
            },
        },
        history: {
            heading: 'История платежей',
            empty: 'Платежи ещё не отправлены.',
            columns: {
                date: 'Дата',
                amount: 'Сумма',
                method: 'Способ',
                status: 'Статус',
                notes: 'Примечания',
                receipt: 'Квитанция',
            },
            statusLabels: {
                APPROVED: 'Одобрено',
                PENDING: 'В ожидании',
                REJECTED: 'Отклонено',
            },
            downloadReceipt: 'Скачать квитанцию',
            previewReceipt: 'Просмотреть квитанцию',
        },
        preview: {
            title: 'Просмотр квитанции',
            close: 'Закрыть просмотр',
            unsupported: 'Предпросмотр недоступен. Скачайте файл, чтобы просмотреть его.',
            loading: 'Загрузка квитанции…',
            error: 'Не удалось загрузить предпросмотр квитанции.',
        },
        messages: {
            paymentSubmitted: 'Платёж отправлен на утверждение.',
        },
        errors: {
            load: 'Не удалось загрузить платёжные данные.',
        },
    },
    es: {
        title: 'Pagos y descuentos',
        loading: 'Cargando información de pagos…',
        buttons: {
            close: 'Cerrar',
        },
        summary: {
            outstanding: 'Saldo pendiente',
            approved: 'Pagos aprobados',
            referralEarnings: 'Ganancias por referidos',
            referralPending: 'Pendientes por referidos',
        },
        referral: {
            heading: 'Descuentos por referido',
            own: {
                heading: 'Tu código de referido',
                codeLabel: 'Código:',
                valueLabel: 'Monto:',
                generatedLabel: 'Generado:',
                usedInfo: 'Lo usó {name} el {date}.',
                usedFallback: 'estudiante ID {id}',
                generateNew: 'Generar nuevo código de referido',
                generate: 'Generar código de referido',
                discountInfo: 'Los estudiantes que usan tu código reciben {amount} de descuento en la matrícula.',
                level2Info: 'Ganas Referido n.º 2 ({amount}) cuando un estudiante aplica tu código.',
                level3Info: 'Si ese estudiante comparte su código y lo usan, ganas Referido n.º 3 ({amount}).',
            },
            apply: {
                heading: 'Aplicar un código de referido',
                placeholder: 'REF-XXXX',
                providerInfo: 'Descuento otorgado por {name}.',
                providerFallback: 'estudiante ID {id}',
                submit: 'Aplicar código',
                appliedLabel: 'Aplicado:',
            },
            messages: {
                generatedWithAmount: '¡Código {code} generado! Compártelo con un nuevo estudiante para que reciba {amount} de descuento en su matrícula.',
                generatedNoAmount: '¡Código {code} generado! Compártelo con un nuevo estudiante.',
                applied: 'Código {code} aplicado correctamente.',
            },
            errors: {
                enterCode: 'Ingresa un código de referido para aplicarlo.',
                generateFailed: 'No se pudo generar el código de referido.',
                applyFailed: 'No se pudo aplicar el código de referido.',
            },
        },
        paymentForm: {
            heading: 'Enviar pago',
            amountLabel: 'Monto',
            methodLabel: 'Método',
            amountPlaceholder: 'Ingresa el monto',
            submit: 'Enviar para aprobación',
            receiptLabel: 'Comprobante de pago (opcional)',
            receiptDescription: 'Sube un comprobante, factura o captura para agilizar la aprobación. Hasta 10 MB en PDF o imagen.',
            receiptSelected: 'Archivo seleccionado:',
            removeReceipt: 'Eliminar archivo',
            methods: [
                { value: 'Online', label: 'En línea' },
                { value: 'Cash', label: 'Efectivo' },
                { value: 'Check', label: 'Cheque' },
                { value: 'Other', label: 'Otro' },
            ],
            errors: {
                amountInvalid: 'Ingresa un monto válido.',
                amountExceeds: 'El monto supera el saldo pendiente.',
                submitFailed: 'No se pudo enviar el pago.',
            },
        },
        history: {
            heading: 'Historial de pagos',
            empty: 'Aún no se han enviado pagos.',
            columns: {
                date: 'Fecha',
                amount: 'Monto',
                method: 'Método',
                status: 'Estado',
                notes: 'Notas',
                receipt: 'Comprobante',
            },
            statusLabels: {
                APPROVED: 'Aprobado',
                PENDING: 'Pendiente',
                REJECTED: 'Rechazado',
            },
            downloadReceipt: 'Descargar comprobante',
            previewReceipt: 'Vista previa del comprobante',
        },
        preview: {
            title: 'Vista previa del comprobante',
            close: 'Cerrar vista previa',
            unsupported: 'La vista previa no está disponible. Descarga el archivo para verlo.',
            loading: 'Cargando comprobante…',
            error: 'No se pudo cargar la vista previa del comprobante.',
        },
        messages: {
            paymentSubmitted: 'Pago enviado para aprobación.',
        },
        errors: {
            load: 'No se pudo cargar la información de pagos.',
        },
    },
};
